module.exports = __webpack_public_path__ + "img/arrange-square-2.72e8c413.svg";